export const dev = {
    endpoints: {
        BITMOJI_API: 'http://devbox-api.bitmoji.com:8080/',
        FORGOT_PASSWORD_ENDPOINT:
            'https://test.bitmoji.com/support/reset-password.html',
        RENDERING_ENDPOINT: 'https://staging-render.bitstrips.com/'
    },
    chrome_ext_id: 'cdfggfdccpgjhbiembonaaiflgambhka',
    snapchat_accounts_login_url: 'https://accounts.snap-dev.net/accounts/oauth2/auth',
    snapchat_redirect_uri: 'https://test.bitmoji.com/account_v2/',
    bitmoji_cookies_info_url: 'https://test.bitmoji.com/cookies.html',
    home_page: '/account_v2'
};

export const staging = {
    endpoints: {
        BITMOJI_API: 'https://staging-api.bitmoji.com/',
        FORGOT_PASSWORD_ENDPOINT:
            'https://test.bitmoji.com/support/reset-password.html',
        RENDERING_ENDPOINT: 'https://staging-render.bitstrips.com/'
    },
    chrome_ext_id: 'cdfggfdccpgjhbiembonaaiflgambhka',
    snapchat_accounts_login_url: 'https://accounts.snap-dev.net/accounts/oauth2/auth',
    snapchat_redirect_uri: 'https://test.bitmoji.com/account_v2/',
    bitmoji_cookies_info_url: 'https://test.bitmoji.com/cookies.html',
    home_page: '/account_v2'
};


export const prod = {
    endpoints: {
        BITMOJI_API: 'https://api.bitmoji.com/',
        FORGOT_PASSWORD_ENDPOINT:
            'https://www.bitmoji.com/support/reset-password.html',
        RENDERING_ENDPOINT: 'https://sdk.bitmoji.com/'
    },
    chrome_ext_id: 'bfgdeiadkckfbkeigkoncpdieiiefpig',
    snapchat_accounts_login_url: 'https://accounts.snapchat.com/accounts/oauth2/auth',
    snapchat_redirect_uri: 'https://www.bitmoji.com/account_v2/',
    bitmoji_cookies_info_url: 'https://www.bitmoji.com/cookies.html',
    home_page: '/account_v2'
};

export const internalProd = {
    endpoints: {
        BITMOJI_API: 'https://api.bitmoji.com/',
        FORGOT_PASSWORD_ENDPOINT:
            'https://www.bitmoji.com/support/reset-password.html',
        RENDERING_ENDPOINT: 'https://sdk.bitmoji.com/'
    },
    chrome_ext_id: 'oibdohnjgphonpepjeekgihohhgmamef',
    snapchat_accounts_login_url: 'https://accounts.snapchat.com/accounts/oauth2/auth',
    snapchat_redirect_uri: 'https://www.bitmoji.com/internal_account_v2/',
    bitmoji_cookies_info_url: 'https://www.bitmoji.com/cookies.html',
    home_page: '/internal_account_v2'
};

// values used in web app
export const config = prod;



// WEBPACK FOOTER //
// ./src/constants/config_constants.js